import '../banners.less';
import './index.less';

import { Col, Row } from 'antd';
import { Link } from 'gatsby';
import React from 'react';
import Fade from 'react-reveal/Fade';

import GreyChevron from '../../../../static/svg/grey-chevron-left.svg';
import theworkoutImg from '../../../images/banners/thecoaching.jpg';
import Breakpoint from '../../../utils/breakpoint';
import Title from '../../BannerShared/Title';
import AppButton from '../../Button';

const TheWorkout = () => (
  <div className="banner-thecoaching">
    <div className="container">
      <Row type="flex" align="middle">
        <Col xs={24} sm={24} md={24} lg={12}>
          <Breakpoint max="lg">
            <div className="box-image-container">
              <img src={GreyChevron} alt="grey chevron" className="left-chevron" />
              <div className="grey-box" />
              <img src={theworkoutImg} alt="The Coaching" />
            </div>
          </Breakpoint>
          <section>
            <Fade>
              <Title title="The Coaching" isTagline />
              <Title title="私教般的体验" />
              <p>我们的小班授课意味着在训练时每一个学员都可以获得教练的关注，确保学员动作精准到位，避免受伤</p>
              <Breakpoint max="lg">
                <div className="buttons-container">
                  <Link to="/locations/">
                    <AppButton color="link">{`View Locations`.toLowerCase()}</AppButton>
                  </Link>
                </div>
              </Breakpoint>
            </Fade>
          </section>
        </Col>

        <Breakpoint min="lg">
          <Col xs={24} sm={24} md={24} lg={12}>
            <Fade>
              <div className="box-image-container">
                <img src={GreyChevron} alt="grey chevron" className="left-chevron" />
                <div className="grey-box" />
                <img src={theworkoutImg} alt="The Coaching" />
              </div>
            </Fade>
          </Col>
        </Breakpoint>
      </Row>
    </div>
  </div>
);

export default TheWorkout;
